var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_542_1842)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    fill: "url(#paint0_linear_542_1842)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.54 52C103.54 80.7188 80.2583 104 51.5395 104C22.8207 104 73.5397 80.7188 73.5397 52C73.5397 23.2812 16 0 51.5395 0C80.2583 0 103.54 23.2812 103.54 52Z",
    fill: "url(#paint1_linear_542_1842)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.00001 79.7108C-8.00001 100.022 29.5384 118 71.5411 118C113.544 118 35.8764 100.022 35.8764 79.7108C35.8764 59.3991 77.0484 26.8113 35.8762 36.8875C-4.38568 46.7411 -8.00001 59.3991 -8.00001 79.7108Z",
    fill: "url(#paint2_linear_542_1842)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_542_1842",
    x1: 22,
    y1: -4.36432e-7,
    x2: 76.5,
    y2: 107.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F277C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865483,
    stopColor: "#E182BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_542_1842",
    x1: 71.7449,
    y1: 0,
    x2: 71.7449,
    y2: 104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F277C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2267"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_542_1842",
    x1: 38,
    y1: 35,
    x2: 38,
    y2: 118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F277C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2267"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_542_1842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    rx: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpBtn);
export default __webpack_public_path__ + "static/media/helpBtn.8e8247be5333b4468588a6f6f16bfb1f.svg";
export { ForwardRef as ReactComponent };